import React from 'react';
import { WingBlank, Carousel } from 'antd-mobile';
import { BackButton, Page, Toolbar } from 'react-onsenui';
import _ from 'lodash';
import './Onboarding.css';
import ButtonRound from '../../components/customForm/ButtonRound';
import { useHistory, useLocation, useParams } from 'react-router-dom';

const boarding = [
    {key: 1, title: 'devenir live scorer pour ce match', description: 'Tu commenteras ce match du bord du terrain et le partageras en direct', img: 'onboarding_deviens_ls.png'},
    {key: 2, title: 'ta mission', description: 'Tu renseigneras le score et les actions de ce match', img: 'onboarding_mission.png'},
    {key: 3, title: 'ta récompense', description: 'Ton live sera suivi et évalué par la communauté', img: 'onboarding_recompense.png'}
]

const Onboarding = () => {
    const history = useHistory();
    const location = useLocation();
    const {maNo} = useParams(); 

    return (
        <Page
            renderFixed={() => (
                <div style={{position: 'absolute', top: 'auto', bottom: '0', margin: '20px', width: '88%', fontWeight: '700', fontFamily: 'fff-equipe'}}>
                    <ButtonRound light onClick={() => history.push(`/subscribe/live/${maNo}${location.search}`)} className='btnRound'>je commence</ButtonRound>
                    <div
                        onClick={() => history.push('/live/demo')}
                        style={{color: '#fff', textAlign: 'center', textTransform: 'uppercase', marginTop: '20px', marginBottom: '20px'}}
                    >
                        voir un exemple de live
                    </div>
                </div>
            )} 
            modifier='ls_onboarding'>
                <WingBlank>
                    <Toolbar modifier='transparent noshadow'>
                        <div className='left'>
                            <BackButton modifier='ls_back' onClick={() => history.push('/matches')}></BackButton>
                        </div>
                    </Toolbar>
                </WingBlank>
                <WingBlank style={{marginTop: '75px', textAlign: 'center', color: '#fff'}}>
                    <div>
                        <Carousel
                            autoplay={false}
                            className="space-carousel"
                        >
                            {
                                _.map(boarding, b => {
                                    return (
                                        <WingBlank style={{marginTop: '60px'}}>
                                            <img src={require(`../../images/${b.img}`)} alt='' style={{width: '165px', height: '165px', margin: 'auto'}} />
                                            <div key={b.key} style={{fontFamily: 'fff-equipe'}}>
                                                <h3 style={{textTransform: 'uppercase', fontWeight: 700, margin: '15px'}}>{b.title}</h3>
                                                <div style={{fontSize: 16}}>{b.description}</div>
                                            </div>
                                        </WingBlank>
                                    )
                                })
                            }
                        </Carousel>
                    </div>
                </WingBlank>
        </Page>
    )
}

export default Onboarding;
